
import { getApiBaseUrl, getApiClient } from "./serviceconfig";
// var apiBaseUrl = "http://localhost:8001";
var apiBaseUrl = getApiBaseUrl();

export async function getAllPumpClearance(cookies, queryParams) {

  let url= `${apiBaseUrl}/pump_clearances/`;
  if (queryParams && typeof queryParams === 'object') {
    const query = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, value);
      }
    });
    const qs = query.toString();
    if (qs) {
      url = `${url}?${qs}`;
    }
  } else if (queryParams && typeof queryParams === 'string') {
    url = `${url}?name=${queryParams}`;
  }
    return getApiClient(cookies).get(url)
      .then(response => response.data);
}


export async function createPumpClearance(cookies, inputs) {
  console.log(JSON.stringify(inputs)+"inputs_services")

  return getApiClient(cookies).put(`${apiBaseUrl}/pump_clearances/${inputs.id}/`,inputs)
  
  
}

export async function updatePumpClearance(cookies, inputs) {

    return getApiClient(cookies)
    .put(`${apiBaseUrl}/pump_clearances/${inputs.id}/`,inputs)
}
  


export async function getPumpClearanceDetails(cookies, PumpClearanceId) {

  return getApiClient(cookies).get(`${apiBaseUrl}/pump_clearances/${PumpClearanceId}/`)
  .then(response => response.data)
}

export async function deletePumpClearance(cookies, PumpClearanceId) {

  return getApiClient(cookies).delete(
    `${apiBaseUrl}/pump_clearances/${PumpClearanceId}/`)
}